import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Space,
  Table,
  notification,
} from "antd";
import { payService } from "api";
import Icons from "assets/icons";
import { InputFields } from "components/common";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { DataFormField } from "types/models/input-field-type";
import { setCallApi } from "redux/reducer/reduxCommon";
import moment from "moment";
import Notification from "components/common/notification/notification";

const { INPUT, SELECT, DATE, CURRENCY } = FIELD_TYPE;

const ModalEdit = ({ isShowModal, handleOk, handleCancel, data }) => {
  // const [minCurrency, setMinCurrency] = useState(0);

  const onChange = (event) => {
    let value = event;
    let total = formData.getFieldValue("thanhTienChuaMienGiam");
    // setMinCurrency(total);
    if (total <= value || total == undefined) {
      formData.setFieldValue("thanhTienConLai", 0);
      return;
    } else {
      const conLai = total - value;
      formData.setFieldValue("thanhTienConLai", conLai);
    }
  };
  // const optionAction = useAppSelector(state => state.reduxCommon.optionModal);
  const inputItems: DataFormField[] = [
    {
      type: INPUT,
      label: "Nội dung",
      name: "content",
      disable: true,
    },
    {
      type: CURRENCY,
      label: "Thành tiền",
      name: "thanhTienChuaMienGiam",
      disable: true,
    },
    {
      type: INPUT,
      label: "Ngày chỉ định",
      name: "ngayChiDinh",
      optionsTime: { showTime: false, format: FORMAT_TIME.dateTime },
      disable: true,
    },
    {
      type: CURRENCY,
      label: "Số tiền miễn giảm",
      name: "soTienMienGiam",
      onChange: onChange,
      rules: [
        {
          required: true,
          message: "Bạn phải nhập trường bắt buộc",
        },
      ],
      disable: data?.benhNhanTuTra <= 0,
    },
    {
      type: CURRENCY,
      label: "Thành tiền còn lại",
      name: "thanhTienConLai",
      disable: true,
    },
    {
      type: INPUT,
      label: "Lý do miễn giảm",
      name: "lyDoMienGiam",
    },
  ];
  const [formData] = Form.useForm();
  const [title, setTitle] = useState("Đề nghị miễn giảm");
  const [fields, setFields] = useState(inputItems);
  // const [dataAdd, setDataAdd] = useState({});
  const idMienGiam = useAppSelector((state) => state.reduxCommon.id2);
  const idLanKham = useAppSelector((state) => state.reduxCommon.id);
  const disPath = useAppDispatch();
  // console.log('dsadsadsadsad', data);

  useEffect(() => {
    // if(optionAction == "ADD"){
    //   setTitle("Thêm miễn giảm");
    //   formData.resetFields;
    //   return;
    // }
    // if(optionAction == "EDIT"){
    //   setTitle("Sửa miễn giảm");
    //   formData.setFieldsValue(data);
    // }
    formData.setFieldsValue(data);
  }, [idLanKham, idMienGiam, isShowModal]);

  const onFinish = async (value) => {
    value = {
      ...value,
      ngayChiDinh: moment(value.ngayChiDinh).format(FORMAT_TIME.day),
      idLanKham: idLanKham,
      idChiDinh: idMienGiam,
    };
    let valueMienGiam = formData.getFieldValue("soTienMienGiam");
    if (valueMienGiam == null || valueMienGiam == undefined) {
      valueMienGiam = 0;
    }
    // console.log("value", value);
    const newData = {
      id: data.id,
      lyDoMienGiam: value.lyDoMienGiam,
      soTienMienGiam: valueMienGiam,
    };
    // setDataAdd(newData);
    // console.log("data", newData);
    await handleOnAddExemption(newData);
    // console.log("option", optionAction);
    // if(optionAction == "ADD"){
    //   handleOnAddSuggestion(value);
    //   return;
    // }
    // if(optionAction == "EDIT"){
    //   handleOnEditSuggestion(newData);
    //   disPath(setCallApi());
    //   handleCancel();
    //   return;
    // }
  };

  const handleOnAddExemption = async (data) => {
    try {
      const response = await payService.addExemptionsById(data).then((res) => {
        // console.log('res thêm mới miễn giảm',res);
        Notification("success", "Thêm miễn giảm thành công");
        disPath(setCallApi());
        handleCancel();
        formData.resetFields();
      });
    } catch (error) {
      console.log("ERROR", error);
      Notification("error", error.response.data);
    }
  };

  const soTienMienGiam = Form.useWatch("soTienMienGiam", formData);

  useMemo(() => {
    if (+soTienMienGiam > 0) {
      fields.find((e) => e.name === "lyDoMienGiam").rules = [
        {
          required: true,
          message: "Bạn phải nhập trường bắt buộc",
        },
      ];
      setFields([...fields]);
    } else setFields([...inputItems]);
  }, [soTienMienGiam]);

  return (
    <Modal
      title={title}
      centered
      open={isShowModal}
      onCancel={handleCancel}
      width={"80%"}
      className="modal-tab-pay"
      footer=""
    >
      <div className="table-results">
        <Form form={formData} onFinish={onFinish}>
          <Space direction="vertical" size={"middle"} style={{ width: "100%" }}>
            <Form.Item>
              <Row gutter={[16, 8]} justify={"space-between"}>
                <InputFields data={fields} />
              </Row>
            </Form.Item>
            <Row gutter={[16, 8]} justify={"end"}>
              <Space>
                <Button
                  key="cancel"
                  type="primary"
                  danger
                  onClick={handleCancel}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  key="submit"
                  type="primary"
                  htmlType="submit"
                  icon={<Icons.save />}
                >
                  Lưu lại
                </Button>
              </Space>
            </Row>
          </Space>
        </Form>
      </div>
    </Modal>
  );
};

export default ModalEdit;
